import classNames from 'classnames';
import { NotFound } from '@/shared/assets/not-found';
import Banner from '@/shared/components/Banner';
import Footer from './Footer';
import { Navbar } from './Navbar';
import useSwapStatus from '../hooks/useSwapStatus';

const Layout = ({
  children,
  resourceNotFound = false,
}: {
  children?: React.ReactNode;
  resourceNotFound?: boolean;
}) => {
  const { status } = useSwapStatus();
  const isSuccess = status?.status === 'completed';

  return (
    <div
      className={classNames(
        'stable-scrollbar-gutter relative flex h-full flex-col overflow-x-hidden transition duration-300 ease-in',
        !isSuccess && 'bg-cf-gray-bg',
      )}
    >
      <div
        className={classNames(
          'silk-curtain saturate-[1.35] transition duration-500 ease-in',
          !isSuccess && 'opacity-0',
          isSuccess && 'opacity-100',
        )}
      />
      <Navbar />
      <Banner app="SWAP" />
      <div className="flex w-full grow p-4 md:items-center md:justify-center">
        <div className="relative w-full max-w-[1248px]">
          {resourceNotFound ? <NotFound /> : children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
